export * from './FooterText';
